import { ArticleApiResponse } from 'core_main/api/articles/types';
import { ArticleCallbackResponse, GetArticlesCallbackResponse } from './types';

export const createArticleCallbackResponse = (
  articleData: ArticleApiResponse,
): ArticleCallbackResponse => {
  const { attributes } = articleData;
  const {
    htmlBody,
    metaDescription,
    title,
    article,
    updatedAt,
    lang,
    slug,
    hash,
    kbUrl,
    knowledgeBaseId,
  } = attributes;

  return {
    // eslint-disable-next-line no-underscore-dangle
    articleId: typeof article === 'string' ? article : article?._id,
    htmlBody,
    title,
    description: metaDescription,
    updatedAt,
    lang,
    slug,
    hash,
    version: articleData.id,
    kbUrl,
    knowledgeBaseId,
  };
};

export const createArticlesCallbackResponse = (
  articles: ArticleCallbackResponse[],
): GetArticlesCallbackResponse => {
  return {
    articles,
  };
};
